import svgUrl from "ni:svgr;QYHENxPzabHeG0ykw_f7cDr_YastyxI-0fYjrlhLhzY";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const UiAddNewColumnSIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" viewBox="0 0 16 16" {...props}><path fill="currentColor" fillRule="evenodd" d="M9 2H4v12h5v-.535a4 4 0 1 1 1 .41v.125a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h5a1 1 0 0 1 1 1v2.5a.5.5 0 0 1-1 0V2Zm2 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm0-5a.5.5 0 0 1 .5.5v1h1a.5.5 0 0 1 0 1h-1v1a.5.5 0 0 1-1 0v-1h-1a.5.5 0 0 1 0-1h1v-1A.5.5 0 0 1 11 8Z" clipRule="evenodd" /></svg>;
const Memo = memo(UiAddNewColumnSIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "ui-node-icon(UiAddNewColumnSIcon)";
}